import {Link} from "react-router-dom";
import logo3 from "../../logo3.png";
import heroPicture from "./hero_picture.png";
import styles from "./Landing.module.css";

// Д3 — публична landing страница. Показва се на „/" за нелогнат потребител.
// Готова за бъдещ домейн: базовият път идва от basename (React Router), няма
// хардкоднати хостове. Контактите са в константа — лесни за смяна при пускане.
const CONTACT = {
    email: "georoud@abv.bg",         // попълва се при пускане на домейна
    phone: "",                       // по желание
};

const FEATURES = [
    {icon: "🔄", title: "Доброволни замени (ДЗ)", text: "Замени на земеделска земя между ползватели с автоматично генерирани PDF протоколи."},
    {icon: "🗺️", title: "Разпределение по масиви", text: "Правно наличната площ се разпределя по масиви и МПО номера, с контрол колко остава за изчертаване."},
    {icon: "📊", title: "Справки", text: "Разнообразни справки по землище и по ползвател — на екран и в PDF."},
    {icon: "📁", title: "Качване на данни", text: "Импорт на изходни данни от CSV файл, с проверки и инкрементално качване."},
];

const STEPS = [
    {n: 1, text: "Качване на изходни данни от файл"},
    {n: 2, text: "Доброволни замени между ползвателите"},
    {n: 3, text: "Разпределение по масиви и МПО"},
    {n: 4, text: "Справки и протоколи"},
];

export const Landing = () => {
    return (
        <div className={styles.page}>
            <header className={styles.header}>
                <div className={styles.brand}>
                    <img src={logo3} alt="APP 4 FARMERS" className={styles.brandLogo}/>
                    <span className={styles.brandName}>APP 4 FARMERS</span>
                </div>
                <Link to="/login" className="btn btn-secondary">Вход</Link>
            </header>

            {/* Щ1: редът е заглавие → подзаглавие → картинка. Преди картинката
                беше първа и на лаптоп надписът оставаше под сгъвката. */}
            <section className={styles.hero}>
                <h1 className={styles.heroTitle}>Платформа за доброволни размени</h1>
                <p className={styles.heroSubtitle}>
                    Софтуер за геодезисти и земеделски стопанства за управление на земеделска земя,
                    доброволни замени и изготвяне на справки и протоколи.
                </p>
                <img src={heroPicture} alt="Доброволна замяна на земеделски парцели"
                     className={styles.heroImage}/>
            </section>

            <h3 className={styles.sectionTitle}>Възможности</h3>
            <div className={styles.cards}>
                {FEATURES.map((f, i) => (
                    <div key={i} className={styles.card}>
                        <div className={styles.cardIcon}>{f.icon}</div>
                        <div className={styles.cardTitle}>{f.title}</div>
                        <div className={styles.cardText}>{f.text}</div>
                    </div>
                ))}
            </div>

            <h3 className={styles.sectionTitle}>Как работи</h3>
            <div className={styles.steps}>
                {STEPS.map(s => (
                    <div key={s.n} className={styles.step}>
                        <div className={styles.stepNum}>{s.n}</div>
                        <div>{s.text}</div>
                    </div>
                ))}
            </div>

            <div className={styles.contact}>
                <h4 style={{color: "var(--app-gold)"}}>Заявка за достъп</h4>
                <p>Достъпът се предоставя след заявка — няма свободна регистрация.</p>
                <p>
                    Имейл: <a href={`mailto:${CONTACT.email}`}>{CONTACT.email}</a>
                    {CONTACT.phone && <> · Телефон: <a href={`tel:${CONTACT.phone}`}>{CONTACT.phone}</a></>}
                </p>
            </div>

            <footer className={styles.footer}>
                <div>
                    <Link to="/terms-of-service">Общи условия</Link>
                    <Link to="/privacy-policy">Политика за поверителност</Link>
                    <Link to="/dpa">DPA</Link>
                </div>
                <div className="mt-2">© {new Date().getFullYear()} APP 4 FARMERS</div>
            </footer>
        </div>
    );
};
